import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionPlayerInfoUpdateCoopInfo } from "../../info/player/actionPlayerInfo";
import { TypeActionCoopInfo } from "../actionCoop";
export var epicCoopJoin = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.JoinCoop), switchMap(function (action) {
        return of(actionPlayerInfoUpdateCoopInfo(action.coopId));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopJoin.ts
// module id = 1808
// module chunks = 3